@if(tenants?.length) {
    <div>
        <p>Please choose a tenant to proceed:</p>
        <div class="form-group">
            <select class="form-select" id="selectTenant" name="selectTenant"
                    [(ngModel)]="selectedTenantKey"
                    (change)="onTenantChange()">
                <option [ngValue]="null" disabled selected hidden>Please Select</option>
                @for (tenant of sortedTenants; track tenant.key) {
                    <option [ngValue]="tenant.key">{{ tenant.name || tenant.key }}</option>
                }
            </select>
            @if (tenant_invalid) {
                <div class="alert alert-danger" id="tenantSelectionError">
                    Please select a Tenant
                </div>
            }
        </div>
        <button *sm-has-not-env-flag="'auroraV1'" unity-button class="primary block my-3"
            id="selectTenantButton"
            [disabled]="!selectedTenant"
            (click)="onSelectButtonClick()">
            Select Tenant
        </button>
        <aurora-button *sm-has-env-flag="'auroraV1'" block variant="primary" class="my-3"
            id="selectTenantButton"
            [disabled]="!selectedTenant"
            (click)="onSelectButtonClick()">
            Select Tenant
        </aurora-button>
        <div class="center mt-3">
            <button *sm-has-not-env-flag="'auroraV1'" unity-button id="changeUserButton" class="link nav-item" (click)="onChangeUser.emit()">
                Change User
            </button>
            <aurora-link-button *sm-has-env-flag="'auroraV1'" (click)="onChangeUser.emit()">
                Change User
            </aurora-link-button>
        </div>
    </div>
} @else {
    <ng-container>
        <p>
            You do not have access to any tenants. Please contact an administrator to add you to a tenant.
        </p>
        <button unity-button class="link nav-item" (click)="onChangeUser.emit()">
            Back to login
        </button>
    </ng-container>
}